// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row--weeks .week-cell {
  background-color: #e0e0e0;
  border-left: 1px solid #aaa;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  color: #343a40;
  box-sizing: border-box;
}

/* заголовок таймлайна */
.timeline-header {
  display: flex;
  width: 100%;
  font-size: 0.875rem;
  -webkit-user-select: none;
          user-select: none;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: white;
  border-bottom: 2px solid #ccc;
}

/* левая колонка кнопок */
.header-controls-container {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  gap: 0.5rem;
}

/* правая часть — три строки */
.header-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

/* общие правила для строк */
.header-row {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

/* 1) месяц */
.header-row--month {
  height: 2.5rem;
  border-bottom: 1px solid #ccc;
}
.month-scale {
  flex: 1 1;
  text-align: center;
  font-weight: 700;
  color: #343a40;
}

/* 2) недели */
.header-row--weeks {
  height: 2rem;
  border-bottom: 1px solid #aaa;
}

/* 3) дни */
.header-row--days {
  height: 2rem;
  border-bottom: 1px solid #aaa;
}
.day-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #aaa;
  font-weight: 700;
  color: #343a40;
  box-sizing: border-box;
  font-size: calc(0.7rem + 0.175 * ((100vw - 1450px) / (1800 - 1450)));
}

.header-row--hours {
  height: 2rem;
  border-bottom: 1px solid #aaa;
}
.hour-cell {
  position: relative;
  display: flex;
  align-items: center;
  font-weight: 500;
  height: 19px;
  color: #343a40;
  box-sizing: border-box;
}
.hour-cell span{
  position: absolute;
  left: -50%;
}

.dayScale span{
  position: absolute;
  left: -25%;
}
.dayScale:first-child{
  opacity: 0;
}

/* убираем старые конфликтующие правила */
.rct-header-root,
.month-cell,
.week-scale,
.day-scale {
  display: none !important;
}

.employee-group-title {
  height: inherit;
  line-height: 1.2;
  padding: 0 1px !important;
  white-space: normal !important;
  height: i;
  .total-container {
    height: inherit;
    border-bottom: 1px solid rgb(224, 224, 224);
    border-left: 1px solid rgb(170, 161, 161);
    justify-content: center;
    display: flex;
    align-items: center;
  }
}

.text-container {
  display: flex;
  gap: 4px;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.value {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  max-width: 250px;
}

.p-overlaypanel-content {
  padding: 1rem;
  min-width: 250px;
}

.p-field-timeline-header {
  margin-bottom: 1rem;
}

.p-field-timeline-header label {
  display: block;
  margin-bottom: 0.5rem;
}

.calendarAssignment-filtergroup {
  width: 220px;
}

.calendarAssingment-timelineHeader .filter-wrap {
  position: relative;
  display: inline-block;
  width: 100%;
}

.calendarAssingment-timelineHeader .filter-wrap .p-inputtext {
  width: 100%;
  padding-right: 2.25rem;
}

.calendarAssingment-timelineHeader .clear-btn {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  padding: 0;
  height: 1.5rem;
  width: 1.5rem;
  line-height: 1.5rem;
}

/* стили для таблицы расписания */
.calendarAssignment-table .department-schedule-item,
.calendarAssignment-table .filled-cell {
  line-height: normal !important;
  background: #d4edda !important;
}

.calendarAssignment-table .filled-cell.absence-item {
  margin-top: 17px !important;
  height: 22px !important;
}

.calendarAssignment-table .filled-cell.absence-item {
  background: #b9b9b980 !important;
}

.calendarAssignment-table .filled-cell.manual-shift {
  background-color: #ffe5b4 !important; /* светло-оранжевый/персиковый, легко отличить от зелёного */
}

.calendarAssignment-table
  .rct-sidebar-row.rct-sidebar-row-even:has(.department-schedule-group) {
  border: 1px solid #777474;
  border-right: none;
  background: #fcf4d4 !important;
  font-weight: 600;
}

.calendarAssignment-table .rct-sidebar-row:has(.employee-group-title) {
  background-color: #fff !important;
}

.calendarAssignment-table .rct-item.filled-cell,
.calendarAssignment-table .rct-item.department-schedule-item {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
}

.calendarAssignment-table .rct-item.filled-cell:not(.absence-item) {
  height: 35px !important;
}

.calendarAssignment-table .rct-item.department-schedule-item {
  height: 55px !important;
}

.calendarAssignment-table .filled-cell .rct-item-content,
.calendarAssignment-table .department-schedule-item .rct-item-content {
  width: inherit;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 0 3px !important;
}

.calendarAssignment-table .pink,
.calendarAssignment-table .deleted-shift,
.calendarAssignment-table .filled-cell.deleted-absence {
  background: rgb(255, 233, 233) !important;
}

.calendarAssignment-table .blue {
  background: rgb(229, 242, 255) !important;
}

.calendarAssignment-table .yellow {
  background: rgb(255, 250, 234) !important;
}

.calendarAssingment-card__column .shift-label {
  width: 130px;
}

.calendar-assignments-group-title-tooltip .p-tooltip-text {
  box-shadow: none !important;
}

.validationErrorsDialog-main-table:has(.validationErrorsDialog-innerTable) {
  padding: 0 !important;
}

.task-item {
  margin-top: 35px;
  background-color: rgb(183 216 249) !important;

  border: 1px solid rgb(26, 111, 179);
  height: 25px !important; /* Для стэкинга, если пересекаются */
  line-height: 25px !important;
  .rct-item-content {
    padding: 1px !important;
    width: inherit;
  }
}

.task-item.is-closed {
  background-color: #ccffcc !important;
}

.react-calendar-timeline .rct-sidebar .rct-sidebar-row {
  display: flex;
  align-items: center;
}

.task-item.cut-right {
  position: relative;
  overflow: hidden;
  border-right: none !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.task-item.cut-right::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 12px;
  height: 100%;
  background: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 2px,
    white 2px,
    white 4px
  );
}

.department-schedule-group .summCell {
  text-align: center;
  font-weight: 'bold';
  background-color: #f0f0f0;
  border-left: 1px solid rgb(170, 161, 161);
}

.calendarAssignments--content-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
}

.calendarAssignments--header {
  width: 100%;
  min-width: 0;
  overflow: visible;
  position: relative;
  z-index: 1;
}

.calendarAssignments--content {
  min-width: var(--calendar-assignments-content-min-width, 1450px);
  width: 100%;
  overflow: visible;
  position: relative;
  isolation: isolate;
}

.calendarAssignments--timeline-header-inner {
  min-width: var(--calendar-assignments-content-min-width, 1450px);
  padding-right: var(--calendar-assignments-scrollbar-offset, 0);
}

.calendarAssignments--timeline-wrapper {
  width: 100%;
  height: var(--calendar-assignments-scroll-height);
  min-height: 320px;
  overflow: hidden;
}

.calendarAssignments--timeline-inner {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: var(--calendar-assignments-timeline-min-width, 1300px);
}

.calendarAssignments--department-timeline {
  flex: 0 0 auto;
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  padding-right: var(--calendar-assignments-scrollbar-offset, 0);
}

.calendarAssignments--employees-timeline {
  flex: 1 1 auto;
  width: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.calendarAssignments--empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: #666;
  font-size: 1.2rem;
}

@media (max-width: 1480px) {
  .calendarAssignments--header {
    max-width: 100vw;
    min-width: auto;
  }

  .calendarAssignments--header #table-header {
    flex-wrap: wrap;
    max-width: 100vw;
    width: 100%;
  }

  .calendarAssignments--header #table-header > *:last-child {
    margin-left: auto;
  }
}

@media (max-width: 768px) {
  .calendarAssignments--content-wrapper {
    touch-action: pan-y;
  }

  .calendarAssignments--employees-timeline {
    touch-action: none;
  }

  .calendarAssignments--header .p-datatable-header {
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }
}

.calendarAssignment-table #table-header > *:first-child {
  min-width: 340px;
  flex-wrap: wrap;
}

.unassignedTasks-badge {
  margin-left: 0.35rem;
}

.unassignedTasks-badge--danger {
  background: #ef4444 !important;
  color: #fff !important;
}

.unassignedTasks-badge--success {
  background: #22c55e !important;
  color: #fff !important;
}

.planningParams-card .planning-params-employee-dropdown {
  flex: 1 1;
  min-width: 0;
}

.planningParams-card .planning-params-field-row-calendar {
  flex: 1 1;
  min-width: 0;
}

@media (max-width: 768px) {
  .calendarAssignments-mobile-action-btn.p-button {
    width: 40px;
    height: 40px;
    min-width: 40px;
    padding: 0;
  }

  .calendarAssignments-more-btn__roles.p-button {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }

  .calendarAssignments-unassigned-mobile-btn.p-button {
    position: relative;
  }

  .calendarAssignments-unassigned-mobile-btn.p-button .p-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    margin-left: 0;
    font-size: 11px;
    line-height: 18px;
  }
}

.rct-item.gray-background {
  background: rgba(200, 200, 200, 0.3) !important;
  border: 1px solid rgba(200, 200, 200, 0.1) !important;
}

.rct-item.interval-even {
  background: rgba(95, 177, 245, 0.45) !important;
  border: 1px solid rgba(33, 150, 243, 0.2) !important;
  z-index: 2 !important;
}

.rct-item.interval-odd {
  background: rgba(59, 132, 192, 0.75) !important;
  border: 1px solid rgba(66, 110, 255, 0.2) !important;
  z-index: 2 !important;
}

.rct-item.non-working-hours {
  background: rgba(200, 200, 200, 0.15) !important;
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/css/CalendarAssignments.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,yCAAyC;AACzC;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,SAAS;EACT;IACE,eAAe;IACf,2CAA2C;IAC3C,yCAAyC;IACzC,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;;EAEE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC,EAAE,4DAA4D;AACpG;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;;EAGE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;;EAE7C,mCAAmC;EACnC,uBAAuB,EAAE,oCAAoC;EAC7D,4BAA4B;EAC5B;IACE,uBAAuB;IACvB,cAAc;EAChB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;AACH;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gEAAgE;EAChE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gEAAgE;EAChE,8DAA8D;AAChE;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iEAAiE;AACnE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gCAAgC;EAChC,8DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;EACnC;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;AACzB","sourcesContent":[".header-row--weeks .week-cell {\n  background-color: #e0e0e0;\n  border-left: 1px solid #aaa;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  color: #343a40;\n  box-sizing: border-box;\n}\n\n/* заголовок таймлайна */\n.timeline-header {\n  display: flex;\n  width: 100%;\n  font-size: 0.875rem;\n  user-select: none;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: white;\n  border-bottom: 2px solid #ccc;\n}\n\n/* левая колонка кнопок */\n.header-controls-container {\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  gap: 0.5rem;\n}\n\n/* правая часть — три строки */\n.header-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n/* общие правила для строк */\n.header-row {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n/* 1) месяц */\n.header-row--month {\n  height: 2.5rem;\n  border-bottom: 1px solid #ccc;\n}\n.month-scale {\n  flex: 1;\n  text-align: center;\n  font-weight: 700;\n  color: #343a40;\n}\n\n/* 2) недели */\n.header-row--weeks {\n  height: 2rem;\n  border-bottom: 1px solid #aaa;\n}\n\n/* 3) дни */\n.header-row--days {\n  height: 2rem;\n  border-bottom: 1px solid #aaa;\n}\n.day-cell {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-left: 1px solid #aaa;\n  font-weight: 700;\n  color: #343a40;\n  box-sizing: border-box;\n  font-size: calc(0.7rem + 0.175 * ((100vw - 1450px) / (1800 - 1450)));\n}\n\n.header-row--hours {\n  height: 2rem;\n  border-bottom: 1px solid #aaa;\n}\n.hour-cell {\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  height: 19px;\n  color: #343a40;\n  box-sizing: border-box;\n}\n.hour-cell span{\n  position: absolute;\n  left: -50%;\n}\n\n.dayScale span{\n  position: absolute;\n  left: -25%;\n}\n.dayScale:first-child{\n  opacity: 0;\n}\n\n/* убираем старые конфликтующие правила */\n.rct-header-root,\n.month-cell,\n.week-scale,\n.day-scale {\n  display: none !important;\n}\n\n.employee-group-title {\n  height: inherit;\n  line-height: 1.2;\n  padding: 0 1px !important;\n  white-space: normal !important;\n  height: i;\n  .total-container {\n    height: inherit;\n    border-bottom: 1px solid rgb(224, 224, 224);\n    border-left: 1px solid rgb(170, 161, 161);\n    justify-content: center;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.text-container {\n  display: flex;\n  gap: 4px;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.value {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  display: inline-block;\n  max-width: 250px;\n}\n\n.p-overlaypanel-content {\n  padding: 1rem;\n  min-width: 250px;\n}\n\n.p-field-timeline-header {\n  margin-bottom: 1rem;\n}\n\n.p-field-timeline-header label {\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.calendarAssignment-filtergroup {\n  width: 220px;\n}\n\n.calendarAssingment-timelineHeader .filter-wrap {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.calendarAssingment-timelineHeader .filter-wrap .p-inputtext {\n  width: 100%;\n  padding-right: 2.25rem;\n}\n\n.calendarAssingment-timelineHeader .clear-btn {\n  position: absolute;\n  top: 50%;\n  right: 0.5rem;\n  transform: translateY(-50%);\n  padding: 0;\n  height: 1.5rem;\n  width: 1.5rem;\n  line-height: 1.5rem;\n}\n\n/* стили для таблицы расписания */\n.calendarAssignment-table .department-schedule-item,\n.calendarAssignment-table .filled-cell {\n  line-height: normal !important;\n  background: #d4edda !important;\n}\n\n.calendarAssignment-table .filled-cell.absence-item {\n  margin-top: 17px !important;\n  height: 22px !important;\n}\n\n.calendarAssignment-table .filled-cell.absence-item {\n  background: #b9b9b980 !important;\n}\n\n.calendarAssignment-table .filled-cell.manual-shift {\n  background-color: #ffe5b4 !important; /* светло-оранжевый/персиковый, легко отличить от зелёного */\n}\n\n.calendarAssignment-table\n  .rct-sidebar-row.rct-sidebar-row-even:has(.department-schedule-group) {\n  border: 1px solid #777474;\n  border-right: none;\n  background: #fcf4d4 !important;\n  font-weight: 600;\n}\n\n.calendarAssignment-table .rct-sidebar-row:has(.employee-group-title) {\n  background-color: #fff !important;\n}\n\n.calendarAssignment-table .rct-item.filled-cell,\n.calendarAssignment-table .rct-item.department-schedule-item {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: 2px;\n}\n\n.calendarAssignment-table .rct-item.filled-cell:not(.absence-item) {\n  height: 35px !important;\n}\n\n.calendarAssignment-table .rct-item.department-schedule-item {\n  height: 55px !important;\n}\n\n.calendarAssignment-table .filled-cell .rct-item-content,\n.calendarAssignment-table .department-schedule-item .rct-item-content {\n  width: inherit;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  padding: 0 3px !important;\n}\n\n.calendarAssignment-table .pink,\n.calendarAssignment-table .deleted-shift,\n.calendarAssignment-table .filled-cell.deleted-absence {\n  background: rgb(255, 233, 233) !important;\n}\n\n.calendarAssignment-table .blue {\n  background: rgb(229, 242, 255) !important;\n}\n\n.calendarAssignment-table .yellow {\n  background: rgb(255, 250, 234) !important;\n}\n\n.calendarAssingment-card__column .shift-label {\n  width: 130px;\n}\n\n.calendar-assignments-group-title-tooltip .p-tooltip-text {\n  box-shadow: none !important;\n}\n\n.validationErrorsDialog-main-table:has(.validationErrorsDialog-innerTable) {\n  padding: 0 !important;\n}\n\n.task-item {\n  margin-top: 35px;\n  background-color: rgb(183 216 249) !important;\n\n  border: 1px solid rgb(26, 111, 179);\n  height: 25px !important; /* Для стэкинга, если пересекаются */\n  line-height: 25px !important;\n  .rct-item-content {\n    padding: 1px !important;\n    width: inherit;\n  }\n}\n\n.task-item.is-closed {\n  background-color: #ccffcc !important;\n}\n\n.react-calendar-timeline .rct-sidebar .rct-sidebar-row {\n  display: flex;\n  align-items: center;\n}\n\n.task-item.cut-right {\n  position: relative;\n  overflow: hidden;\n  border-right: none !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.task-item.cut-right::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 12px;\n  height: 100%;\n  background: repeating-linear-gradient(\n    -45deg,\n    transparent,\n    transparent 2px,\n    white 2px,\n    white 4px\n  );\n}\n\n.department-schedule-group .summCell {\n  text-align: center;\n  font-weight: 'bold';\n  background-color: #f0f0f0;\n  border-left: 1px solid rgb(170, 161, 161);\n}\n\n.calendarAssignments--content-wrapper {\n  overflow-x: auto;\n  overflow-y: hidden;\n  width: 100%;\n  max-width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n\n.calendarAssignments--header {\n  width: 100%;\n  min-width: 0;\n  overflow: visible;\n  position: relative;\n  z-index: 1;\n}\n\n.calendarAssignments--content {\n  min-width: var(--calendar-assignments-content-min-width, 1450px);\n  width: 100%;\n  overflow: visible;\n  position: relative;\n  isolation: isolate;\n}\n\n.calendarAssignments--timeline-header-inner {\n  min-width: var(--calendar-assignments-content-min-width, 1450px);\n  padding-right: var(--calendar-assignments-scrollbar-offset, 0);\n}\n\n.calendarAssignments--timeline-wrapper {\n  width: 100%;\n  height: var(--calendar-assignments-scroll-height);\n  min-height: 320px;\n  overflow: hidden;\n}\n\n.calendarAssignments--timeline-inner {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  min-width: var(--calendar-assignments-timeline-min-width, 1300px);\n}\n\n.calendarAssignments--department-timeline {\n  flex: 0 0 auto;\n  width: 100%;\n  border-bottom: 1px solid #e0e0e0;\n  padding-right: var(--calendar-assignments-scrollbar-offset, 0);\n}\n\n.calendarAssignments--employees-timeline {\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.calendarAssignments--empty-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  color: #666;\n  font-size: 1.2rem;\n}\n\n@media (max-width: 1480px) {\n  .calendarAssignments--header {\n    max-width: 100vw;\n    min-width: auto;\n  }\n\n  .calendarAssignments--header #table-header {\n    flex-wrap: wrap;\n    max-width: 100vw;\n    width: 100%;\n  }\n\n  .calendarAssignments--header #table-header > *:last-child {\n    margin-left: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .calendarAssignments--content-wrapper {\n    touch-action: pan-y;\n  }\n\n  .calendarAssignments--employees-timeline {\n    touch-action: none;\n  }\n\n  .calendarAssignments--header .p-datatable-header {\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.calendarAssignment-table #table-header > *:first-child {\n  min-width: 340px;\n  flex-wrap: wrap;\n}\n\n.unassignedTasks-badge {\n  margin-left: 0.35rem;\n}\n\n.unassignedTasks-badge--danger {\n  background: #ef4444 !important;\n  color: #fff !important;\n}\n\n.unassignedTasks-badge--success {\n  background: #22c55e !important;\n  color: #fff !important;\n}\n\n.planningParams-card .planning-params-employee-dropdown {\n  flex: 1 1 0%;\n  min-width: 0;\n}\n\n.planningParams-card .planning-params-field-row-calendar {\n  flex: 1 1 0%;\n  min-width: 0;\n}\n\n@media (max-width: 768px) {\n  .calendarAssignments-mobile-action-btn.p-button {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    padding: 0;\n  }\n\n  .calendarAssignments-more-btn__roles.p-button {\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n  }\n\n  .calendarAssignments-unassigned-mobile-btn.p-button {\n    position: relative;\n  }\n\n  .calendarAssignments-unassigned-mobile-btn.p-button .p-badge {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    min-width: 18px;\n    height: 18px;\n    margin-left: 0;\n    font-size: 11px;\n    line-height: 18px;\n  }\n}\n\n.rct-item.gray-background {\n  background: rgba(200, 200, 200, 0.3) !important;\n  border: 1px solid rgba(200, 200, 200, 0.1) !important;\n}\n\n.rct-item.interval-even {\n  background: rgba(95, 177, 245, 0.45) !important;\n  border: 1px solid rgba(33, 150, 243, 0.2) !important;\n  z-index: 2 !important;\n}\n\n.rct-item.interval-odd {\n  background: rgba(59, 132, 192, 0.75) !important;\n  border: 1px solid rgba(66, 110, 255, 0.2) !important;\n  z-index: 2 !important;\n}\n\n.rct-item.non-working-hours {\n  background: rgba(200, 200, 200, 0.15) !important;\n  border: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
